import styled, { css } from "styled-components";

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.mainBg};
  border-radius: 6px;
  padding: 12px 12px 12px 12px;
  gap: 15px;
`;

export const AccordionHeader = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AccordionContent = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;

  &.close-content {
    display: none;
  }
`;

export const AccordionTitle = styled.p`
  font-weight: 600;
  font-size: 1.3rem;
  color: ${(props) => props.theme.colors.primary};
  white-space: nowrap;
`;

export const AccordionTitleData = styled.p`
  font-weight: 700;
  font-size: 1.4rem;
  margin: 0px 5px 0px 0px;
`;

export const AccordionIcon = styled.div<{ isOpen: boolean }>`
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
`;
